import {Application as StimulusApplication} from "@hotwired/stimulus";
import FormWithPhoneNumberInputsController from "./form_with_phone_number_inputs_controller";

export function startStimulusApp() {
    const stimulusApp = StimulusApplication.start();
    stimulusApp.register("form-with-phone-number-inputs", FormWithPhoneNumberInputsController);
}
